/* Hide Carousel Arrows if only 1 slide */

window.onload = function () {
  // IE suport for objectfit
  var objectFitImages = require('object-fit-images')
  objectFitImages()

  const carouselWrapper = document.querySelector('.jumbotron .carousel .carousel-inner')
  const controlPrev = document.querySelector('.carousel-control-prev')
  const controlNext = document.querySelector('.carousel-control-next')

  if (carouselWrapper && controlPrev && controlNext) {
    if (carouselWrapper.childElementCount <= 1) {
      controlPrev.classList.add('is--disabled')
      controlNext.classList.add('is--disabled')
    }
  }
  // prependAnchors() Evtl. später benötigt

  // Buchungsformular

  if (document.querySelector('form[id^="buchungsformular-"]')) {
    const formWrapper = document.querySelector('form[id^="buchungsformular-"]')
    const t3ContentId = formWrapper.getAttribute('id').split('-')[1]

    if (document.querySelector('#buchungsformular-member')) {
      const member = document.querySelector('#buchungsformular-' + t3ContentId + 'member #buchungsformular-' + t3ContentId + 'member-0')
      const noMember = document.querySelector('#buchungsformular-member #buchungsformular-member-1')
      const requiredRadiosLabel = document.querySelector('#buchungsformular-aufnahme .form-check span')
      const requiredRadio0 = document.querySelector('#buchungsformular-aufnahme-0')
      const requiredRadio1 = document.querySelector('#buchungsformular-aufnahme-1')

      member.onclick = function () {
        removeAufnahmeRequired(requiredRadiosLabel, requiredRadio0, requiredRadio1)
      }

      noMember.onclick = function () {
        setAufnahmeRequired(requiredRadiosLabel, requiredRadio0, requiredRadio1)
      }
    }

    // I think this is not used (anymore?)
    if (document.querySelector('#buchungsformularZweigstelle-member')) {
      const member = document.querySelector('#buchungsformularZweigstelle-member #buchungsformularZweigstelle-member-0')
      const noMember = document.querySelector('#buchungsformularZweigstelle-member #buchungsformularZweigstelle-member-1')
      const requiredRadiosLabel = document.querySelector('#buchungsformularZweigstelle-aufnahme .form-check span')
      const requiredRadio0 = document.querySelector('#buchungsformularZweigstelle-aufnahme-0')
      const requiredRadio1 = document.querySelector('#buchungsformularZweigstelle-aufnahme-1')

      member.onclick = function () {
        removeAufnahmeRequired(requiredRadiosLabel, requiredRadio0, requiredRadio1)
      }

      noMember.onclick = function () {
        setAufnahmeRequired(requiredRadiosLabel, requiredRadio0, requiredRadio1)
      }
    }
    // I think -- end
  }

  function setAufnahmeRequired (requiredRadiosLabel, requiredRadio0, requiredRadio1) {
    requiredRadiosLabel.classList.add('required')
    requiredRadio0.required = true
    requiredRadio1.required = true
  }

  function removeAufnahmeRequired (requiredRadiosLabel, requiredRadio0, requiredRadio1) {
    requiredRadiosLabel.classList.remove('required')
    requiredRadio0.required = false
    requiredRadio1.required = false
  }
}

window.addEventListener('orientationchange', function () {
  window.location.reload()
})

const outputTotalPrice = document.querySelector('#booking-totalPrice')
if (outputTotalPrice) {
  const getFinalPriceFromLocalstorage = window.localStorage.getItem('dhh-booking-total-price')
  outputTotalPrice.innerHTML = 'Der Gesamtpreis für diesen Kurs beträgt ' + '<strong>' + getFinalPriceFromLocalstorage + '</strong>' + ' €. <br>' + 'Ein möglicher Treuerabatt wird nachträglich ermittelt und abgezogen.'
}
const summaryOutputPrice = document.querySelector('#booking #summary-totalPrice')
if (summaryOutputPrice) {
  const getFinalPriceFromLocalstorage = window.localStorage.getItem('dhh-booking-total-price')
  summaryOutputPrice.style.display = 'block'
  summaryOutputPrice.innerHTML = 'Der Gesamtpreis für diesen Kurs beträgt ' + '<strong>' + getFinalPriceFromLocalstorage + '</strong>' + ' €. <br>' + 'Ein möglicher Treuerabatt wird nachträglich ermittelt und abgezogen.'
}
const courseNo = document.querySelector('#booking-Course_No')
if (courseNo) {
  const submitData = e => {
    // calculate and set final price in localStorage
    const checkedPriceField = document.querySelector('#booking-PackageType input:checked')
    const neoprenFields = document.querySelectorAll('#booking-NeoExists .form-check-input')
    if (checkedPriceField) {
      const checkedPrice = +checkedPriceField.nextElementSibling.textContent.replace(/\D/g, '')
      const hasNoOwnNeo = document.querySelector('#booking-NeoExists input[value="0"]')

      let finalBookingPrice
      if (neoprenFields.length) {
        finalBookingPrice = checkedPrice + (hasNoOwnNeo.checked ? 75 : 0)
      } else {
        finalBookingPrice = checkedPrice
      }
      window.localStorage.setItem('dhh-booking-total-price', finalBookingPrice)
    }

    // save address data in localStorage
    const bookingAddressExtra = document.querySelector('#booking-Address').value
    const bookingAddress = document.querySelector('#booking-Address2').value
    const bookingPostCode = document.querySelector('#booking-PostCode').value
    const bookingCity = document.querySelector('#booking-City').value
    const bookingCountryName = document.querySelector('#booking-CountryName').value
    window.localStorage.setItem('dhh-booking-address', bookingAddress)
    window.localStorage.setItem('dhh-booking-address-extra', bookingAddressExtra)
    window.localStorage.setItem('dhh-booking-post-code', bookingPostCode)
    window.localStorage.setItem('dhh-booking-city', bookingCity)
    window.localStorage.setItem('dhh-booking-country-name', bookingCountryName)
  }
  const submitBtn = document.querySelector('button[type="submit"]')
  submitBtn.addEventListener('click', submitData)
}

const childAddressSameAsParents = document.querySelector('#booking-childAddressSameAsParents_LG')
if (childAddressSameAsParents) {
  const addressExtraParents = document.querySelector('#booking-Address_LG')
  const addressParents = document.querySelector('#booking-Address2_LG')
  const postCodeParents = document.querySelector('#booking-PostCode_LG')
  const cityParents = document.querySelector('#booking-City_LG')
  const countryNameParents = document.querySelector('#booking-CountryName_LG')

  const clickChildAddressSameAsParents = e => {
    if (e.currentTarget.checked) {
      if (addressExtraParents) {
        const getBookingAddressExtra = window.localStorage.getItem('dhh-booking-address-extra')
        if (getBookingAddressExtra) {
          addressExtraParents.value = getBookingAddressExtra
        }
      }
      if (addressParents) {
        const getBookingAddress = window.localStorage.getItem('dhh-booking-address')
        if (getBookingAddress) {
          addressParents.value = getBookingAddress
        }
      }
      if (postCodeParents) {
        const getBookingPostCode = window.localStorage.getItem('dhh-booking-post-code')
        if (getBookingPostCode) {
          postCodeParents.value = getBookingPostCode
        }
      }
      if (cityParents) {
        const getBookingCity = window.localStorage.getItem('dhh-booking-city')
        if (getBookingCity) {
          cityParents.value = getBookingCity
        }
      }
      if (countryNameParents) {
        const getBookingCountryName = window.localStorage.getItem('dhh-booking-country-name')
        if (getBookingCountryName) {
          countryNameParents.value = getBookingCountryName
        }
      }
    } else {
      if (countryNameParents) {
        countryNameParents.value = ''
      }
      if (cityParents) {
        cityParents.value = ''
      }
      if (postCodeParents) {
        postCodeParents.value = ''
      }
      if (addressParents) {
        addressParents.value = ''
      }
      if (addressExtraParents) {
        addressExtraParents.value = ''
      }
    }
  }
  childAddressSameAsParents.addEventListener('click', clickChildAddressSameAsParents)
}

// prevent user from submitting the booking form multiple times
const bookingForm = document.querySelector('form#booking')
const formButtons = document.getElementById('form-buttons')
const finalSubmitButton = document.getElementById('btn-page-submit')
const previousButton = document.getElementById('btn-page-previous')

function showWaitingtext () {
  if (finalSubmitButton) {
    const waitingButton = document.createElement('button')
    const waitingButtonText = document.createTextNode('bitte warten')
    waitingButton.appendChild(waitingButtonText)
    waitingButton.setAttribute('disabled', '')
    waitingButton.classList.add('btn', 'btn-primary')
    formButtons.appendChild(waitingButton)
  }
}

function setDisable () {
  if (finalSubmitButton) {
    finalSubmitButton.classList.add('hide')
    previousButton.classList.add('hide')
  }
}

if (bookingForm) {
  bookingForm.addEventListener('submit', () => {
    showWaitingtext()
    setDisable()
  })
}

/* Add pseudo anchor elements, like bootstrap already does with sections, before containers. z.zT. nicht benutzt */
// var prependAnchors = function () {
//   var containers = document.querySelectorAll('.main-content > .container')

//   containers.forEach(container => {
//     var anchor = document.createElement('span')
//     anchor.classList.add('anchor')
//     if (container.firstElementChild.id) {
//       anchor.id = container.firstElementChild.id + '-anchor'
//     }
//     container.parentNode.insertBefore(anchor, container)
//   })
// }
